import EfficiencyDetailTabComponent from './EfficiencyDetailTab';

const EfficiencyDetailTab = EfficiencyDetailTabComponent;

export default EfficiencyDetailTab;
